<ng-container *ngFor="let step of steps; let i = index; let isLast = last">
  <div>
    <ng-container
      [ngTemplateOutlet]="step.content"
      [ngTemplateOutletContext]="{ step: step, i: i }"
    ></ng-container>
  </div>
</ng-container>

<!-- <div [ngTemplateOutlet]="selected ? selected.content : null"></div> -->
